<template>
  <div class="flex justify-between text-xs" :class="overLimit ? 'text-danger' : 'text-gray'">
    <span>{{ overLimit ? 'You have exceeded the character limit' : ''}}</span>
    <span>{{ count }} / {{ limit }}</span>
  </div>
</template>

<script>
export default {
  name: 'CharacterCounter',

  props: {
    count: {
      type: Number,
      required: true
    },
    limit: {
      type: Number,
      required: true
    }
  },

  computed: {
    overLimit() {
      return this.count > this.limit
    }
  }
}
</script>
